import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';

import { FETCH_CONSENT_HUB_LINK } from './types';
import { consentHubLink } from '../../api/consentHub';

export const fetchConsentHubLink = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const sourceData = consentHubLink(state);
  dispatch(thunkProgress(FETCH_CONSENT_HUB_LINK, sourceData));
};
